<div class="modal-overlay" *ngIf="showModal" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2>Apply Leave</h2>
      <button class="close-button" (click)="onClose()">&times;</button>
    </div>

    <div class="modal-body">
      <form [formGroup]="applyLeaveForm">
        <div class="dropdown-container">
          <app-dropdown
            class="dropdown"
            [options]="filteredLeaveType"
            [label]="'Leave Type'"
            [displayKey]="'label'"
            [valueKey]="'value'"
            [required]="true"
            (dropdownChange)="handleLeaveType($event)"
            formControlName="leaveType"
          ></app-dropdown>
        </div>
        <div class="datepicker-container">
          <app-date-range
            [dateLabel]="dateLabel"
            [startDatePlaceholder]="startDatePlaceholder"
            [endDatePlaceholder]="endDatePlaceholder"
            [cardComponent]="'LEAVE_APPLICATION'"
            [required]="true"
            [publicHolidays]="publicHolidays"
            [paidLeaveDates]="paidLeaveDates"
            [unpaidLeaveDates]="unpaidLeaveDates"
            [halfPaidLeaveDates]="halfPaidLeaveDates"
            [halfUnpaidLeaveDates]="halfUnpaidLeaveDates"
            [billableDates]="billableDates"
            [processedSummary]="processedLeaveSummary"
            (dateRangeSelected)="handleDateRangeChange($event)"
            (monthChanged)="onCalendarMonthChanged($event)"  
          >
          </app-date-range>
        </div>
        
        <div class="leaves">
          <app-input-field
            [label]="'Number of Leaves'"
            formControlName="numberOfLeaves"
            [type]="'text'"
            [required]="true"
          >
          </app-input-field>
        </div>
        <div class="comments-container">
          <app-input-field
            [label]="'Comments'"
            formControlName="comments"
            [type]="'textarea'"
            [rows]="3"
            [required]="true"
          >
          </app-input-field>
        </div>
        <div class="form-group">
          <div class="file-upload-container">
            <app-file-upload
              label="Upload Leave Attachment"
              [error]="fileError"
              fileTypeText="PDF, PNG, JPEG format only, upto 3 MB"
              [selectedFile]="uploadedLeaves"
              (fileSelected)="onLeaveSelected($event)"
              (fileRemoved)="onLeaveRemoved()"
            >
            </app-file-upload>
          </div>
        </div>

        <div class="modal-footer">
          <app-button-group
            [label]="'Cancel'"
            [buttonType]="'Secondary'"
            [cssClass]="'btn cancel-btn'"
            (click)="onClose()"
          ></app-button-group>
          <app-button-group
            [label]="'Save'"
            [buttonType]="'Primary'"
            [cssClass]="'btn btn-primary'"
            (click)="onSubmit()"
          ></app-button-group>
        </div>
      </form>
    </div>
  </div>
</div>